import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const sliderEl = document.querySelector( '#results-cta-slider' );

      if ( sliderEl && sliderEl.querySelectorAll( '.splide__slide' ).length > 1 ) {
        new Splide( sliderEl, {
          type: 'loop',
          autoplay: true,
          interval: 6000,
          perPage: 1,
          arrows: false,
          pagination: false,
          pauseOnHover: true,
        } ).mount( {AutoScroll} );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'bento-hero', COMPONENT );
} )( app );
